import request from "@/utils/request";

export function ConfirmEzam(data) {
  return request({
    url: "/ezam/Confirm",
    method: "post",
    data: data,
  });
}

export function GetEzamHistory() {
  return request({
    url: "/ezam/GetHistory",
    method: "post",
  });
}

export function GetWorkReportHistory(data) {
  return request({
    url: "/ezam/GetWorkReportHistory",
    method: "post",
    data: data,
  });
}

export function SaveReport(data) {
  return request({
    url: "/ezam/SaveReport",
    method: "post",
    data: data,
  });
}

export function CancelRequest(data) {
  return request({
    url: "/ezam/Cancel",
    method: "post",
    data: {
      Srl_TabliqEzam: data.Fserial,
      Des_Fard: data.Description,
    },
  });
}

export function getEzamHokm(ezamId) {
  return request({
    url: "/ezam/gethokm?ezamId=" + ezamId,
    method: "post",
  });
}
